import React, { useEffect, useMemo, useState } from "react";
import { VsiBubble } from "../styled/App.styled";
import { Spinner } from "reactstrap";
import BarChart from "../components/BarChart";
import { useDataWithRoute } from "../utils/hooks";
import { useVsiAppContext } from "../stores/VsiApp";

const groupOptions = [
  { value: "total_cost", label: "Total Cost ($)", route: "business_unit_chargeback_proc" },
  { value: "total_used", label: "Utilization", route: "business_unit_chargeback_proc" }
];

const reportOptions = [
  {
    label: "Array Summary by BU",
    route: "business_unit_chargeback_proc",
    value: "business_unit"
  },
  {
    label: "BU Summary by Array",
    route: "business_unit_chargeback_proc",
    value: "device_name"
  }
];

export default function BUChargebackReport({ params }) {

  const {
    defaultOption,
    defaultReportOption
  } = useMemo(() => {

    const searchOption = params?.find?.(param => param.param === "option")?.value;
    const searchReportOption = params?.find?.(param => param.param === "report")?.value;

    return {
      defaultOption: searchOption ? groupOptions.find(({ value }) => searchOption === value.toString()) : groupOptions[0],
      defaultReportOption: searchReportOption ? reportOptions.find(({ value }) => searchReportOption === value.toString()) : reportOptions[0]
    };
  }, [params]);

  const { value: optionValue } = defaultOption;
  const { value: reportOptionValue } = defaultReportOption;

  const { client: { clientId }, getPeriodId } = useVsiAppContext();
  const periodId = getPeriodId("BUSINESS UNIT");

  const route = useMemo(() => `/api/v6/report/business_unit_chargeback_proc?client_id=${clientId}&period_id=${periodId}`, [clientId, periodId]);
  const [{ recordsets: [chargebackData, buList, dList] }, { isLoading }] = useDataWithRoute(route);

  const { isSorted, chargebackIndex } = useMemo(() => {
    const sortedChargeback = [...chargebackData].sort((a, b) => b[optionValue] - a[optionValue]);

    const isBu = reportOptionValue === "business_unit";
    const buKey = isBu ? reportOptionValue : "business_unit";
    const deviceKey = isBu ? "device_name" : reportOptionValue;
    const index = {};

    sortedChargeback.forEach(d => {
      const key = `${d[buKey]}::${d[deviceKey]}`;
      index[key] = d;
    });

    return {
      isSorted: !isLoading,
      // doing this rather than looking up stuff every time.. will need to go back and do this on the regular screen too
      chargebackIndex: index
    };
  }, [chargebackData, optionValue, isLoading]);

  const { categories, chartSeries } = useMemo(() => {

    let chartSeries = [];
    let categories = [];

    if (isSorted) {
      const isBu = reportOptionValue === "business_unit";
      const buKey = isBu ? reportOptionValue : "business_unit";
      const deviceKey = isBu ? "device_name" : reportOptionValue;
      const categoryList = isBu ? buList : dList;
      const seriesList = isBu ? dList : buList;

      categories = categoryList.map(m => m[isBu ? "business_unit" : "device_name"]);
      chartSeries = seriesList.map(s => {
        return {
          name: s[isBu ? "device_name" : "business_unit"],
          //BLEH
          data: categoryList.map(c => {
            const buObj = isBu ? c : s;
            const devObj = isBu ? s : c;

            const buPart = isBu ? buObj[buKey] : buObj.business_unit;
            const devPart = isBu ? devObj.device_name : devObj[deviceKey];

            const key = `${buPart}::${devPart}`;
            return chargebackIndex[key]?.[optionValue] || 0;
          })
        };
      });
    }

    return {
      categories,
      chartSeries
    };
  }, [reportOptionValue, optionValue, isSorted, buList, dList, chargebackIndex]);

  return (
    isLoading && !isSorted ? (
      <Spinner color={"success"} />
    ) : (
      <VsiBubble>
        <BarChart categories={categories}
                  height={400}
                  series={chartSeries}
                  scrollHeight={chartSeries?.[0]?.data?.length * 35 || null}
                  disableLegend={true}
                  title={""}
                  yAxisTitle={defaultOption.label} />
      </VsiBubble>
    )
  );

}